/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	var socialMedia = require('lib/generic/socialmedia/SocialMedia').getController();
	var encodeCount = require('lib/generic/socialmedia/SocialMedia').encodeCount;


	'use strict';
	/*globals Tc, debug */

	/**
	 * Social Share Button Implementation
	 *
	 * @author Matthias Inauen, Marc Althoff
	 * @namespace Tc.Module
	 * @class SocialShare
	 * @extends Tc.Module
	 */
	Tc.Module.SocialShare = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;
			mod.displayAggregatedShareCount = mod.$ctx.hasClass('skinSocialShareTeaser') ? true : false;
			mod.displayShareCount = mod.$ctx.hasClass('showShareCount');
			mod.attachEvents();

			// init share count if enabled on the module
			if (mod.displayShareCount) {
				if (mod.displayAggregatedShareCount) {
					// init aggregated share count on the teaser
					mod.initAggregatedShareCountBadges();
				} else {
					// init individual button share count on a series of buttons
					mod.initButtonShareCountBadges();
				}
			}

			callback();
		},

		/**
		 * Returns a list of active social media services in this module
		 *
		 * @method getActiveServices
		 * @returns {Array}
		 */
		getActiveServices: function () {
			var mod = this,
				services = [],
				service;
			// run through all share-buttons. Stored on the <a> descendant
			// is a data property called service, which contains the name of the
			// service this button represents.
			mod.$ctx.find('.share-button').each(function () {
				service = $(this).find('> a').data('service');
				if (service) {
					services.push(service);
				}
			});

			return services;
		},

		/**
		 * Attach click events to buttons:
		 * Show popups instead of direct links
		 *
		 * @method attachEvents
		 * @return void
		 */
		attachEvents: function () {
			var mod = this;

			// Print triggers a simple window.print
			mod.$ctx.find('.share-button.print > a').on('click', $.proxy(mod.printPage, mod));

			// Anything else gets sent to track & trigger
			mod.$ctx.find('.share-button:not(".print") > a').on('click', $.proxy(mod.shareThisPage, mod));
		},

		/**
		 * Print the page
		 *
		 * @method printPage
		 */
		printPage: function () {
			window.print();
		},

		shareThisPage: function(event) {
			var mod = this,
				urlToTrackInRoamingTool,
				clickedShareButton = $(event.target).closest('.share-button'), // get the share button in which the <a> was clicked
				serviceName = clickedShareButton.find('a').data('service');

			// for some services we can not read the share count back from the external service
			// hence, we track it in a swisscom internal database
			if((serviceName === 'mail' ||
				serviceName === 'xing' ||
				serviceName === 'linkedin' ||
				serviceName === 'facebook' ||
				serviceName === 'whatsapp' ||
				serviceName === 'twitter') &&
				!clickedShareButton.data('alreadySharedOnce')) {
				urlToTrackInRoamingTool = SCS.Url.stripProtocolFromUrl($('link[rel=canonical]').attr('href')) || window.SCS.Url.stripPathPrefixFromUrl(document.location.hostname + document.location.pathname);
				mod.trackClickCountInternally(urlToTrackInRoamingTool, serviceName);
			}

			// open the share dialog to allow the user to post the url to their stream on
			// the according profile
			if( serviceName !== 'mail' ){
				event.preventDefault();
				mod.displayShareDialog(event.currentTarget.href);
			}

			// add the click count to the button
			mod.addClickCount(clickedShareButton);
		},


		/**
		 * trackClickCountInternally - write the click count to a swisscom database
		 *
		 * @method trackClickCountInternally
		 * @param url - the url to track
		 * @param serviceName - the name of the service
		 */
		trackClickCountInternally: function (url, serviceName) {
			$.ajax({
				method: 'POST',
				type: 'POST',
				url: '/portal-app/roamingtool/public/social-media-statistics',
				data: JSON.stringify({url: encodeURI(url), service: serviceName}),
				contentType: 'application/json; charset=utf-8',
				dataType: 'json'
			});
		},

		displayShareDialog: function(dialogUrl) {
			var w = 500,
				h = 500,
				left = (screen.width / 2) - (w / 2),
				top = (screen.height / 2) - (h / 2);

			window.open(dialogUrl, 'socialShareWindow', 'toolbar§=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
		},

		/**
		 * Fakes the share count increase on the client side, without provoking a page reload.
		 * @param shareButton
		 */
		addClickCount: function (shareButton) {
			if (!shareButton.data('alreadySharedOnce')) {
				// update the badge
				this.addShareCountToShareButton(shareButton, 1, shareButton.find('.shareWithCount'));
				// Lock the element from adding further share counts
				shareButton.data('alreadySharedOnce', 'true');
			}
		},

		/**
		 * Update the share count on the button, if displaying of button is configured
		 * If there is already a button with a share count, the new share count will be added.
		 *
		 * @param button - jquery object. Expected to be of type '.share-button'
		 * @param newShareCount - Number - the new share count to add to the button
		 * @param shareCountParent - jquery object - The parent where to append the share Count Badge to.
		 */
		addShareCountToShareButton: function (button, newShareCount, shareCountParent) {
			if (this.displayShareCount) {
				var badge, shareCount;

				if (newShareCount > 0) {
					// get the current badge or create a new one.
					badge = (button.find('.badge').length) ? button.find('.badge') : $('<span class="badge"/>');
					shareCount = (badge.data('actualShareCount')) ? badge.data('actualShareCount') : 0;
					shareCount += newShareCount;
					badge.text(encodeCount(shareCount));
					// store the actual share count so 2999 + 1 will result in the display of 3K
					badge.data('actualShareCount', shareCount);
					// if it's a new badge. append it to the right place
					if (!badge.parent().length && shareCountParent) {
						shareCountParent.append(badge);
					}
				}
			}
		},

		/**
		 * Initialize Share Count Badges on the share buttons
		 */
		initButtonShareCountBadges: function () {
			var mod = this, button;
			$.each(mod.getActiveServices(), function (index, service) {
				socialMedia.shareCount(service)
					.then(function (rv) {
						button = mod.$ctx.find('.share-button').has('a[data-service=' + service + ']');
						mod.addShareCountToShareButton(button, rv.count, button.find('.shareWithCount'));
					}, function () {
						debug.log('Tc.Module.SocialShare.js >> promise rejected >> service: ', service);
					});
			});
		},

		initAggregatedShareCountBadges: function () {
			var mod = this,
				shareCount = mod.$ctx.find('.shareCount'),
				commentCount = mod.$ctx.find('.commentCount');
			// separate call for all social media
			socialMedia.shareCount(socialMedia.servicesByCategory('shareCount'), shareCount.data('fullurl'))
				.then(function (rv) {
					if (rv.counts) {
						shareCount.removeClass('hidden');
					}
					mod.addShareCountToShareButton(shareCount, rv.counts, shareCount);
				}, function () {
					mod.log('aggregate share count rejected. Services aggregated ', socialMedia.servicesByCategory('shareCount'));
				});

			// separate call for disqus
			socialMedia.shareCount('disqus', commentCount.data('disqusUrl'))
				.then(function (rv) {
					if (rv.count) {
						commentCount.removeClass('hidden');
					}
					mod.addShareCountToShareButton(commentCount, rv.count, commentCount);
				}, function () {
					mod.log('Tc.Module.SocialShare.js >> disques count rejected.');
				});
		}
	});
}(Tc.$, window, window.SCS));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.SocialShare.js
// module id = 183
// module chunks = 0